<template>
  <div class="container pc-page-main" >
    <div class="pc-header-layout">
      <div class="pc-header">
        <img src="~@/assect/logo.png" alt="logo">
        <div class="school-name">{{schoolName}}</div>
        <div class="out-login" @click="goOut">
          <span class="out-icon"></span>
          退出登录
        </div>
      </div>
    </div>
    <div class="pc-search-layout">
<!--      <div class="pc-tabs-back"></div>-->
      <div class="pc-search">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="maskShow">
          <el-tab-pane label="我的课程" name="curriculum">
            <div class="my-curriculum">
              <div class="pc-search-one">
                <searchBox
                    ref="searchBox"
                    :courseName="courseName"
                    @searchChanges="searchChanges"
                />
              </div>
              <div class="pc-search-two">
                 <div class="pc-left-list">
                   发布时间：
                   <span class="pc-left-item"
                         :class="{'pc-btn-sul':currTime === index}"
                         v-for="(item,index) in ReleaseTime"
                         @click="toggleOpenTime(item,index,'my')"
                   > {{ item.label }} </span>
                 </div>
                <div class="pc-right-time" v-show="currTime === 4">
                  <el-date-picker
                      style="width: 160px;"
                      v-model="startTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
                  <span style="margin: 0 10px;">~</span>
                  <el-date-picker
                      style="width: 160px;"
                      v-model="endTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
                  <span class="pc-btn-reset" @click="timeReset">重置</span>
                  <span class="pc-btn-sul" @click="getTeacherIdAndStart">确认</span>
                </div>
              </div>
              <div class="pc-search-three">
                <div class="pc-type-list">
                  学科分类：
                  <span class="pc-left-item"
                        :class="{'pc-btn-sul':currType === index}"
                        v-for="(item,index) in classification"
                        @click="toggleType(item,index)"
                  > {{ item.subjectName }} </span>
                </div>
              </div>
              <div class="pc-search-four">
              <div class="pc-type-list">
                审核状态：
                <span class="pc-left-item"
                      :class="{'pc-btn-sul':currState === index}"
                      v-for="(item,index) in AuditStatus"
                      @click="toggleState(item,index)"
                > {{ item.label }} </span>
              </div>
            </div>
            </div>
            <div class="pc-my-list">
              <div class="not-data" v-if="curriculumData.length === 0">暂无数据</div>
              <div class="pc-list-style" v-for="item in curriculumData">
                <curriculumList
                    ref="curriculumList"
                    :obj="item"
                    :releaseShow="true"
                    :isIdentity="teaOrStudent"
                    @release="release"
                    @editFn="editFn"
                    @deleteRow="deleteRow"
                    @download="download"
                />
              </div>
            </div>
          </el-tab-pane>
<!--          <el-tab-pane label="我的公开课" name="openClass">-->
<!--            <div class="my-curriculum">-->
<!--              <div class="pc-search-one"> <searchBox ref="searchBox" /> </div>-->
<!--              <div class="pc-search-two">-->
<!--                <div class="pc-left-list">-->
<!--                  发布时间：-->
<!--                  <span class="pc-left-item"-->
<!--                        :class="{'pc-btn-sul':OpenClassTime === index}"-->
<!--                        v-for="(item,index) in ReleaseTime"-->
<!--                        @click="toggleOpenTime(item,index,'open')"-->
<!--                  > {{ item.label }} </span>-->
<!--                </div>-->
<!--                <div class="pc-right-time" v-show="currTime === 4">-->
<!--                  <el-date-picker-->
<!--                      style="width: 160px;"-->
<!--                      v-model="listQuery.startTime"-->
<!--                      type="date"-->
<!--                      placeholder="选择日期">-->
<!--                  </el-date-picker>-->
<!--                  <span style="margin: 0 10px;">~</span>-->
<!--                  <el-date-picker-->
<!--                      style="width: 160px;"-->
<!--                      v-model="listQuery.endTime"-->
<!--                      type="date"-->
<!--                      placeholder="选择日期">-->
<!--                  </el-date-picker>-->
<!--                  <span class="pc-btn-reset" @click="timeReset">重置</span>-->
<!--                  <span class="pc-btn-sul" @click="getTeacherIdAndStart">确认</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="pc-search-three">-->
<!--                <div class="pc-type-list">-->
<!--                  学科分类：-->
<!--                  <span class="pc-left-item"-->
<!--                        :class="{'pc-btn-sul':OpenClassType === index}"-->
<!--                        v-for="(item,index) in classification"-->
<!--                        @click="toggleOpenType(item,index)"-->
<!--                  > {{ item.subjectName }} </span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="pc-my-list">-->
<!--              <div class="pc-list-style" v-for="item in openClassData">-->
<!--                <curriculumList-->
<!--                    ref="curriculumList"-->
<!--                    :obj="item"-->
<!--                    :releaseShow="false"-->
<!--                    @release="release"-->
<!--                    @editFn="editFn"-->
<!--                    @deleteRow="deleteRow"-->
<!--                />-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
    <div class="pc-list-layout"></div>

  </div>
</template>

<script>
	import {
		getSubject,
		getSelectSchool,
		getTeacherIdAndStart,
    downloadVideo
	} from "@/api/home/index.js";
	import {
		setEdit,
		deleteCourse,
	} from "@/api/details/index.js";
  import searchBox from "./searchBox";
  import curriculumList from "./curriculumList";

	export default {
		name: "index",
    components:{searchBox, curriculumList, },
    data() {
			return {

				ReleaseTime:[
          {value:'all',label:'全部'},
          {value:'week',label:'近一周'},
          {value:'month',label:'近一月'},
          {value:'halfYear',label:'近半年'},
          {value:'diy',label:'自定义'},
        ],
				classification:[],
				AuditStatus:[
          {value:'',label:'全部'},
          {value:1 ,label:'待审核'},
          {value:0 ,label:'已审核'},
        ],
        curriculumData:[],
				openClassData:[],
        currTime:0 ,
				OpenClassTime:0 ,
        currType:0,
				OpenClassType:0,
				currState:0,

				listQuery:{},
				activeName:'curriculum',

				maskShow:false,

				user:{},
				courseName:'',
				schoolName:'学校名称',
				teaOrStudent:'',
				avatar:'',
        subjectId:'',
				gradeId:'',
				isStart:'',
        endTime:'',
        startTime:'',

			}
    },
    mounted() {
	    if(this.isMOBILE()){
		    this.$router.push({
			    path:'/home'
		    })
	    }
	    this.user = JSON.parse(localStorage.user);
	    this.teaOrStudent = this.user.isProperty;
	    this.avatar = this.user.avatar;
	    this.schoolName = localStorage.userName;

	    //获取学科列表
	    this.getSubject();
	    //获取年级列表
	    // this.getSelectSchool();
	    //获取视频列表
	    this.getTeacherIdAndStart();
    },
		methods:{
	    handleClick(tab) {
		    console.log(tab);
	    },
			searchChanges(y) {
				this.courseName = y
			},
	    toggleTime(item,idx) {

      },
	    toggleType(item,idx) {
	    	this.currType = idx
		    this.subjectId = item.subjectId
		    this.getTeacherIdAndStart()
      },
	    toggleState(item,idx) {
	    	this.currState = idx
        this.isStart = item.value
        this.getTeacherIdAndStart()
      },
	    toggleOpenTime(item,idx,type) {
	    	if(type === 'my'){
			    this.currTime = idx
        }else{
			    this.OpenClassTime = idx
        }
		    if(idx===4) return
		    switch (idx) {
		    	case 0:
				    this.endTime = ''
				    this.startTime = ''
            break
			    case 1:
				    this.endTime = this.format(new Date())
				    this.startTime = this.format(new Date(new Date().getTime() - 1000*60*60*24*7))
				    break
			    case 2:
				    this.endTime = this.format(new Date())
				    this.startTime = this.format(new Date(new Date().getTime() - 1000*60*60*24*30))
				    break
			    case 3:
				    this.endTime = this.format(new Date())
				    this.startTime = this.format(new Date(new Date().getTime() - 1000*60*60*24*180))
				    break
		    }
		    this.getTeacherIdAndStart()
      },
      toggleOpenType(item,idx) {
	    	this.OpenClassType = idx
        this.subjectId = item.subjectId
      },
			getSelectSchool() {},
			getTeacherIdAndStart() {
				this.maskShow = true;
				const data = {
					subjectId: this.subjectId, //学科id
					// gradeId: this.gradeId, //年级id
					courseName: this.courseName,
					userId: this.user.userId,
					isStart: this.isStart,
          startDate: this.startTime,
          endDate: this.endTime,
				};
				getTeacherIdAndStart(data).then((res) => {
					if (res.code == 0) {
						this.curriculumData = res.teacherCourse;
						this.maskShow = false;
					} else {
						this.$toast(res.msg);
						this.maskShow = false;
					}
				});
			},
			getSubject() {
				const data = { schoolId: this.user.schoolId };
				getSubject(data).then((res) => {
					if (res.code === 0) {
						let data = res.subjectList
            data.unshift({subjectName:'全部',subjectId:''})
						this.classification = data
						if(data.length > 0){
							this.subjectId = data[0].subjectId
            }
						// for (let i = 0; i < res.subjectList.length; i++) {
						// 	const element = res.subjectList[i];
						// 	this.classification.push(element);
						// }
					} else {
						this.$toast(res.msg);
					}
				});
			},
			format(dat){
				//获取年月日，时间
				let year = dat.getFullYear();
				let mon = (dat.getMonth()+1) < 10 ? "0"+(dat.getMonth()+1) : dat.getMonth()+1;
				let data = dat.getDate()  < 10 ? "0"+(dat.getDate()) : dat.getDate();
				// var hour = dat.getHours()  < 10 ? "0"+(dat.getHours()) : dat.getHours();
				// var min =  dat.getMinutes()  < 10 ? "0"+(dat.getMinutes()) : dat.getMinutes();
				// var seon = dat.getSeconds() < 10 ? "0"+(dat.getSeconds()) : dat.getSeconds();
				// var newDate = year +"-"+ mon +"-"+ data +" "+ hour +":"+ min +":"+ seon;
				let r = year +"-"+ mon +"-"+ data;
				return r;
			},
			timeReset() {
	    	this.startTime = ''
        this.endTime = ''
      },

	    release(obj) {
		    this.$confirm('是否发布该课程？', '发布提示', {
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确认',
			    cancelButtonText: '取消',
			    closeOnClickModal: false
		    }).then(() => {
			    const data = {
				    courseId: obj.courseId,
				    isOpen: obj.isOpen,
				    isStart:'0'
			    }
			    setEdit(data).then((res) => {
				    if (res.code == 0) {
				    	this.$notify({
						    message: "发布成功！",
						    type: "success",
						    duration: 2000,
              })
					    this.getTeacherIdAndStart()
				    }
			    });
        })
	    },
	    editFn(obj) {
		    this.$router.push({
          name:'subjectEdit',
          params:{
          	videoId: obj.courseId,
	          identity:'tea'
          }
        })
	    },
      deleteRow(obj) {
	      this.$confirm('是否删除该课程？', '删除提示', {
		      distinguishCancelAndClose: true,
		      confirmButtonText: '确认',
		      cancelButtonText: '取消',
		      closeOnClickModal: false
	      }).then(() => {
		      const data = { courseId: obj.courseId };
		      deleteCourse(data)
		      .then((res) => {
			      if (res.code == 0) {
				      this.$notify({
					      message: "操作成功",
					      type: "success",
					      duration: 1000,
				      });
				      this.getTeacherIdAndStart()
			      } else {
				      this.$notify({
					      message: "操作失败，请重试",
					      type: "danger",
					      duration: 1000,
				      });
			      }
		      })
		      .catch(function (error) {
			      this.$notify({
				      message: "操作失败，请重试",
				      type: "danger",
				      duration: 1000,
			      });
		      });
	      })
	    },
      download(obj){
        const url = process.env.NODE_ENV === 'production' ? process.env.prop_url : process.env.dev_url
        window.open(`${url}/app/onlinecourse/downloadVideo?courseAddress=${obj.courseAddress}&filename=${obj.courseName}`)
      },
	    goOut() {
		    localStorage.removeItem("Token");
		    localStorage.removeItem("user");
		    // localStorage.removeItem("firstload");
		    this.$router.push("/login");
		    localStorage.setItem("footActive", 0);
		    this.Emit.$emit("footNum", 0);
	    },
			isMOBILE () {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iphone|ipod|ios|iPad|Android|Mobild|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|webOS|Symbian|Windows Phone)/i
				)
				return flag
			}
    },
	}
</script>

<style lang="less" scoped>
  .pc-page-main{
    background: #fff;
  }
  .pc-header-layout{
    background: rgba(231,240,242,1);
    .pc-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 70%;
      height: 45px;
      margin: 0 auto;
      /*width: 100%;*/
      /*height: 100%;*/
      padding: 0 20px;
      font-size: 16px;
      .out-login{
        .out-icon{
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url("~@/assect/mine/icon_4.png") no-repeat;
          background-size: 100% 100%;
        }

      }
    }
  }
  .pc-search-layout{
    .pc-tabs-back{
      position: absolute;
      height: 230px;
      width: 100%;
      background: rgba(249,249,251,1);
    }
    .pc-search{
      width: 70%;
      margin: 0 auto;
      font-size: 14px;
    }
    .my-curriculum > div{
      margin-bottom: 10px;
    }
    .pc-search-one{
      width: 65%;
      margin: 0 auto;
    }
    .pc-search-two{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .pc-left-item{
      display: inline-block;
      margin: 0 8px;
      border-radius: 5px;
      padding: 8px 20px;
      cursor: pointer;
    }
    .not-data{
      padding-top: 200px;
      color: #a7a8a9;
      text-align: center;
      font-size: 16px;
    }
  }
  .pc-btn-sul{
    padding: 8px 20px;
    background: rgba(41,200,149,1);
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
  }
  .pc-btn-reset{
    margin: 0 15px;
    display: inline-block;
    padding: 7px 19px;
    border: 1px solid rgba(41,200,149,1);
    color: rgba(41,200,149,1);
    border-radius: 5px;
    cursor: pointer;
  }
  .pc-list-style:not(:last-child){
    border-bottom: 1px solid #cecece;
  }
</style>